import { defineComponent as _defineComponent } from 'vue'
import apiHelpers from '@/utils/api'
import { ref, computed, watch, nextTick, onMounted } from 'vue'
import store from '@/store'
import { AloDbFleet, isAloDbFleetCoverage, isAloDbFleetFormation } from '@/models/alodb/AloDbFleet'
import MissionDetailLogBook from '@/components/mission/MissionDetailLogBook.vue'
import MissionDetailLogBookRow from '@/components/mission/MissionDetailLogBookRow.vue'
import { buildFleetUIStateId } from '@/models/ui/FleetUiState'


export default /*#__PURE__*/_defineComponent({
  __name: 'FleetDetailLogBook',
  props: {
    fleet: null,
    isleft: { type: Boolean },
    uiid: null,
    isVisible: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
  fleet: AloDbFleet
  isleft: boolean
  uiid: string
  isVisible: boolean
};



const missions = computed(
  () =>
    props.fleet.param?.missionIds
      ?.map(id => store.myGetters?.missionsById[id])
      ?.filter(m => !!m)
      ?.sort((m, m1) =>
        !props.fleet.activeMissionIds.includes(m.misId!)
          ? 1
          : !props.fleet.activeMissionIds.includes(m1.misId!)
          ? -1
          : props.fleet.activeMissionIds.findIndex(misId => m.misId == misId) -
            props.fleet.activeMissionIds.findIndex(misId => m1.misId == misId),
      ) ?? [],
)

const gliders = computed(() => missions.value.map(m => ({ id: m.misId, libelle: m.gliKey })))

const selectedGliderIdx = ref(0)

const message = ref('')

const logbook = ref()

const fleet_uiid = computed(() => {
  return buildFleetUIStateId(props.fleet.FLE_ID!, 'detail')
})

// recupere le state de travail
const fleetState = computed(() => {
  // retourne un FleetUiState
  return store.myGetters.fleetUiStateByUiid(fleet_uiid.value)
})

const fleetIco = computed(() => {
  return isAloDbFleetCoverage(props.fleet)
    ? 'mdi-select-group'
    : isAloDbFleetFormation(props.fleet)
    ? 'mdi-vector-circle'
    : 'mdi-multicast'
})

const showTabs = ref(true)
onMounted(() => {
  setTimeout(() => {
    showTabs.value = false
    nextTick(() => {
      showTabs.value = true
    })
  }, 100)
})

function downloadFile(url: string) {
  apiHelpers.downloadFile(url)
}

function sendMessage() {
  store.myActions.UI_FLEET_LOGBOOK_SEND_MESSAGE_REQUEST({ fleId: props.fleet.FLE_ID!, message: message.value.trim() })
  message.value = ''
}

if (props.fleet.FLE_ID) store.myActions.UI_FLEET_LOGBOOK_REQUEST(props.fleet.FLE_ID)

watch(
  () => props.fleet.FLE_ID,
  () => {
    store.myActions.UI_FLEET_LOGBOOK_REQUEST(props.fleet.FLE_ID!)
  },
)

watch(
  () => fleetState.value.logBookItems,
  () => {
    nextTick(() => {
      logbook.value.scrollTop = logbook.value.scrollHeight
    })
  },
)

return { __sfc: true,props, missions, gliders, selectedGliderIdx, message, logbook, fleet_uiid, fleetState, fleetIco, showTabs, downloadFile, sendMessage, store, MissionDetailLogBook, MissionDetailLogBookRow }
}

})